import {useQuery} from "@tanstack/react-query";
import {getData} from "../getters/getData.js";


export const useDictSearch = (url, enabled = true) => {
    return useQuery({
        queryKey: [`dict_search__${url}`],
        queryFn: async () => getData(url),
        enabled: enabled
    })
}